import React from "react";
import { Page } from "app";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { SubmissionError } from "redux-form";
import { Form, FormError, SubmitButton } from "app/forms";
import * as fields from "app/auth/fields";
import { reset } from "app/auth/actions";
import { RESET } from "app/auth/constants";
import Helmet from "react-helmet";
import { Classes } from "@blueprintjs/core";

let ResetForm = props => {
  const { handleSubmit, submitting, valid, error } = props;
  return (
    <Form className="pt-card pt-elevation-1" onSubmit={handleSubmit}>
      <fields.Email props={{ className: Classes.LARGE }} />
      <FormError error={error} submitting={submitting} />
      <SubmitButton
        valid={valid}
        submitting={submitting}
        text="Reset password"
        className="pt-large"
      />
    </Form>
  );
};

ResetForm = reduxForm({ form: "resetForm" })(ResetForm);

class Reset extends React.Component {
  state = { done: false };

  handleSubmit = values => {
    return this.props.reset(values).catch(error => {
      if (error && error.type === RESET.ERROR) {
        throw new SubmissionError({ _error: error });
      }
      throw error;
    });
  };

  success = () => {
    this.setState({ done: true });
  };

  render() {
    const { handleSubmit, success, state: { done } } = this;
    const title = "Reset password";
    return (
      <Page className="pt-ui-text-large pt-running-text">
        <Helmet title={title} />
        <h1>{title}</h1>
        {done ? (
          <div className="pt-callout pt-intent-primary pt-icon-envelope">
            <div className="pt-ui-text-large">Email sent!</div>
          </div>
        ) : (
          <ResetForm onSubmit={handleSubmit} onSubmitSuccess={success} />
        )}
      </Page>
    );
  }
}

export default connect(null, dispatch => ({
  reset: values => dispatch(reset(values))
}))(Reset);



// WEBPACK FOOTER //
// ./src/app/auth/Reset.js